var map = {
	"./classicsauce.jpg": 143,
	"./eelsauce.jpg": 144,
	"./extraspicymayo.jpg": 145,
	"./housesauce.jpg": 146,
	"./mangosauce.jpg": 147,
	"./ponzusauce.jpg": 148,
	"./srirachahotsauce.jpg": 149,
	"./strawberrysauce.jpg": 150,
	"./sweetmayo.jpg": 151,
	"./yumyumsauce.jpg": 152
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 142;


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/flavor ^\.\/.*$
// module id = 142
// module chunks = 0